/* eslint-disable import/no-named-as-default */
import React from "react";
import { Provider } from "react-redux";
import store from "../../store";
import Desktop from "./Desktop";
import Mobile from "./Mobile";
import ErrorBoundary from "../shared/error/ErrorBoundary";
import Theme from "../../theme/theme";

const ActivityFeedProvider = () => (
  <ErrorBoundary>
    <Theme>
      <Provider store={store}>
        {window.innerWidth < 768 ? <Mobile /> : <Desktop />}
      </Provider>
    </Theme>
  </ErrorBoundary>
);

export default ActivityFeedProvider;
